// extracted by mini-css-extract-plugin
export var label = "_b5-1";
export var reminder = "_b5-0";